import { render, staticRenderFns } from "./BracketsRoundsScheduleDialog.vue?vue&type=template&id=7240e17d"
import script from "./BracketsRoundsScheduleDialog.vue?vue&type=script&lang=js"
export * from "./BracketsRoundsScheduleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports